import React from 'react'

const ArrowRight = ({color, height, width}: {color?: string; height?: string; width?: string}) => {
  return (
    <svg
      width={width || '18'}
      height={height || '13'}
      viewBox='0 0 18 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.6888 1.89807C10.2832 1.5096 10.2832 0.879771 10.6888 0.491302C11.0943 0.102833 11.7518 0.102833 12.1574 0.491302L17.6958 5.79657C17.8986 5.9908 18 6.24538 18 6.49995C18 6.63483 17.972 6.76343 17.9212 6.88072C17.8705 6.99804 17.7954 7.10796 17.6958 7.20334L12.1574 12.5086C11.7518 12.8971 11.0943 12.8971 10.6888 12.5086C10.2832 12.1201 10.2832 11.4903 10.6888 11.1018L14.4545 7.49469L1.03846 7.49469C0.464933 7.49469 -2.50614e-06 7.04933 -2.45811e-06 6.49995C-2.41008e-06 5.95057 0.464933 5.50521 1.03846 5.50521L14.4545 5.50521L10.6888 1.89807Z'
        fill={color || '#66666'}
      />
    </svg>
  )
}

export default ArrowRight
